import { getEndPoint } from './getEndPoint'
export const getAuthor = id => {
  return getEndPoint('wp/v2/users/' + id)
}
